<template>
  <mdb-container>
    <div class="gp-has-header">
      <mdb-card class="text-left mt-4">
        <mdb-card-header color="warning-color text-white">
          <h5>
            <mdb-icon icon="bomb"/>
            Error
          </h5>
        </mdb-card-header>
        <mdb-card-body>
          We're sorry, but the host {{ currUrl }} is not yet properly configured.
        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>
</template>

<script>
import {mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon} from 'mdbvue';

export default {
  name: 'Error',
  components: {
    mdbCard, mdbCardHeader, mdbCardBody, mdbIcon, mdbContainer
  },
  computed: {
    currUrl() {
      return window.location.host
    }
  },
  props: {
    error: {
      type: Error,
      default: null
    }
  }
};
</script>

<style scoped>
</style>
